import React, { useState } from "react";
// import { NoteContext } from "./noteContext";
import { AuthInfo } from "./noteContext";
const AuthProvider = (props) => {
  const [userAddress, setUserAddress] = useState(
    localStorage.getItem("user_id")
  );
  const value = { userAddress, setUserAddress };
  return <AuthInfo.Provider value={value}>{props.children}</AuthInfo.Provider>;
};

export default AuthProvider;
